import { createActionHelpers } from 'vuex-loading';
import fileDownload from 'js-file-download';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    temporaryData: [],
    setTemporaryDataCount: null,
    data: [],
    operators: [],
    retailers: [],
    toggle: true,
    mode: 1,
    addAllMatching: false,
    selectedSize: {
        id: 7,
        name: '4x10 51x26mm',
        row: 4,
        column: 10,
        width: 51,
        height: 26,
        font_barcode: 11,
        font_price: 22,
        barcode_width: 1,
        barcode_height: 30,
        barcode_margin_bottom: 7,
        margin_top: 5,
        margin_bottom: 5,
    },
    sizes: [
        {
            id: 1,
            name: '1x2 213x84mm',
            row: 1,
            column: 2,
            width: 213 + 33 + 7,
            height: 84 + 11 + 3,
            font_barcode: 28,
            font_price: 54,
            barcode_width: 3,
            barcode_height: 60,
            orientation: 'landscape',
        },
        {
            id: 2,
            name: '2x5 100x50mm',
            row: 2,
            column: 5,
            width: 100 + 10 + 3,
            height: 50 + 5 + 1,
            font_barcode: 19,
            font_price: 37,
            barcode_width: 3,
            barcode_height: 54,
            barcode_margin_bottom: 14,
            margin_top: 5,
        },
        {
            id: 3,
            name: '2x7 105x39mm',
            row: 2,
            column: 7,
            width: 105 + 11 + 2,
            height: 39 + 3 + 2,
            font_barcode: 19,
            font_price: 28,
            barcode_width: 3,
            barcode_height: 46,
            barcode_margin_bottom: 14,
            margin_top: 5,
        },
        {
            id: 4,
            name: '3x7 52x39mm',
            row: 3,
            column: 7,
            width: 52 + 1,
            height: 39 + 3 + 1,
            font_barcode: 13,
            font_price: 26,
            barcode_width: 1,
            barcode_height: 35,
            inline_text_height: 3,
            margin_top: 5,
            margin_left: 7,
        },
        {
            id: 5,
            name: '3x7 69x42mm',
            row: 3,
            column: 7,
            width: 69 + 4,
            height: 42 + 3,
            font_barcode: 14,
            font_price: 27,
            barcode_width: 2,
            barcode_height: 38,
            inline_text_height: 3,
            margin_top: 5,
        },
        {
            id: 6,
            name: '3x8 70x37mm',
            row: 3,
            column: 8,
            width: 70 + 4,
            height: 37 + 2,
            font_barcode: 16,
            font_price: 27,
            barcode_width: 2,
            barcode_height: 45,
            margin_top: 2,
        },
        {
            id: 10,
            name: '3x9 70x33mm',
            row: 3,
            column: 9,
            width: 70 + 5.3,
            height: 33 + 1.2,
            font_barcode: 18,
            font_price: 27,
            barcode_width: 2,
            barcode_height: 45,
            margin_left: 0.3,
            margin_top: 0.3,
        },
        {
            id: 7,
            name: '4x10 51x26mm',
            row: 4,
            column: 10,
            width: 51,
            height: 26,
            font_barcode: 11,
            font_price: 22,
            barcode_width: 1,
            barcode_height: 30,
            margin_top: 5,
            margin_bottom: 5,
        },
        {
            id: 8,
            name: '4x10 53x29mm',
            row: 4,
            column: 10,
            width: 53,
            height: 29,
            font_barcode: 12,
            font_price: 23,
            barcode_width: 1,
            barcode_height: 37,
            margin_top: 5,
        },
        {
            id: 9,
            name: '4x7 51x38mm',
            row: 4,
            column: 7,
            width: 51,
            height: 38 + 2,
            font_barcode: 13,
            font_price: 25,
            barcode_width: 1,
            barcode_height: 40,
            inline_text_height: 3,
            margin_top: 5,
        },
    ],
    inactiveData: [],
    inactiveToggle: true,
    inactiveProducts: [],
};

const getters = {
    data: state => state.data,

    toggle: state => state.toggle,

    mode: state => state.mode,

    operators: state => state.operators,

    retailers: state => state.retailers,

    selectedSize: state => state.selectedSize,

    sizes: state => state.sizes,

    addAllMatching: state => state.addAllMatching,

    temporaryData: state => state.temporaryData,

    inactiveData: state => state.inactiveData,

    inactiveToggle: state => state.inactiveToggle,
};

const mutations = {
    assignProducts(state, data) {
        let unit_price = data.unit_price;

        if (data.pivot && data.pivot.unit_price) {
            unit_price = data.pivot.unit_price;
        }

        // Grab the hidden status from the pivot table if it exists
        let isHidden =
            data.pivot && data.pivot.hidden !== undefined
                ? data.pivot.hidden
                : data.entry_hidden;

        let product = {
            id: data.id,
            name: data.name,
            code: data.code,
            unit_price: unit_price,
            entry_hidden: isHidden,
            ignore: data.ignore ? data.ignore : false,
            font_size: calculateFontSize(state.selectedSize, data.name),
        };

        const index = state.data.findIndex(p => p.id === product.id);

        if (index !== -1 && !product.ignore) {
            state.data.splice(index, 1);
        } else {
            const find = state.data.find(p => p.id === product.id);

            if (!find) {
                state.data.push(product);
            }
        }

        state.inactiveData = state.data.filter(
            p => p.entry_hidden === 1,
        ).length;
        state.inactiveProducts = state.data.filter(p => p.entry_hidden === 1);
    },

    unAssignProducts(state, data) {
        const index = state.data.findIndex(p => p.id === data.id);

        if (index !== -1) {
            state.data.splice(index, 1);
        }
    },

    assignOperators(state, data) {
        const index = state.operators.findIndex(p => p.id === data.id);

        if (index !== -1) {
            state.operators.splice(index, 1);
        } else {
            state.operators.push(data);
        }
    },

    assignRetailers(state, data) {
        const index = state.retailers.findIndex(p => p.id === data.id);

        if (index !== -1) {
            state.retailers.splice(index, 1);
        } else {
            state.retailers.push(data);
        }
    },

    setToggle(state, data) {
        state.toggle = data;
    },

    setMode(state, data) {
        state.mode = data;
    },

    reset(state) {
        state.data = [];
        state.mode = 1;
        state.toggle = true;
    },

    assignSelectedSize(state, data) {
        state.selectedSize = data;

        if (state.data && state.data.length > 0) {
            state.data.forEach(p => {
                p.font_size = calculateFontSize(state.selectedSize, p.name);
            });
        }
    },

    setAddAllMatching(state, data) {
        state.addAllMatching = data;
    },

    setTemporaryData(state, data) {
        state.temporaryData = data;
    },

    setTemporaryDataCount(state, data) {
        state.setTemporaryDataCount = data;
    },

    setInactiveToggle(state, data) {
        state.inactiveToggle = data;
    },
};

const actions = {
    async print({ dispatch, state }, { id, model, column, filters, currency }) {
        startLoading(dispatch, 'generate-barcode');

        let data = {
            products: handleProducts(),
            size: state.selectedSize,
            addAllMatching: state.addAllMatching,
            inactiveToggle: state.inactiveToggle,
            currency,
            id,
            model,
            column,
            filters,
        };

        await axios({
            url: Laroute.route('franchise.shelf.label.print'),
            responseType: 'blob',
            method: 'post',
            headers: { Accept: 'multipart/form-data' },
            data,
        })
            .then(response => {
                fileDownload(
                    response.data,
                    `shelf_label_${state.selectedSize.name}.pdf`,
                );

                endLoading(dispatch, 'generate-barcode');
            })
            .catch(error => {
                endLoading(dispatch, 'generate-barcode');
                throw error;
            });
    },

    async sendEmail({ dispatch, state }, { id, model, column, filters, type }) {
        const url = Laroute.route('franchise.shelf.label.send.email');

        startLoading(dispatch, 'generate-barcode');

        let params = {
            products: handleProducts(),
            size: state.selectedSize,
            addAllMatching: state.addAllMatching,
            inactiveToggle: state.inactiveToggle,
            id,
            model,
            column,
            filters,
            type,
        };

        if (type === 'operators') {
            Object.assign(params, {
                operators: state.operators,
            });
        } else {
            Object.assign(params, {
                retailers: state.retailers,
            });
        }

        try {
            axios.post(url, params);
            endLoading(dispatch, 'generate-barcode');
        } catch (e) {
            endLoading(dispatch, 'generate-barcode');
            throw e;
        }
    },
};

function handleProducts() {
    let inactiveIds = state.inactiveProducts.map(item => item.id);

    if (inactiveIds.length > 0 && state.inactiveToggle) {
        return state.data.filter(p => !inactiveIds.includes(p.id));
    } else {
        return state.data;
    }
}

function calculateFontSize(selectedSize, name) {
    let ratio;
    let defaultSize;
    let offSet;

    switch (state.selectedSize.id) {
        case 1: {
            ratio = 12;
            defaultSize = 43;
            offSet = 43;
            break;
        }
        case 2: {
            ratio = 3.8;
            defaultSize = 38;
            offSet = 38;
            break;
        }
        case 3: {
            ratio = 3.2;
            defaultSize = 32;
            offSet = 32;
            break;
        }
        case 4: {
            ratio = 1.8;
            defaultSize = 27;
            offSet = 27;
            break;
        }
        case 5: {
            ratio = 2.3;
            defaultSize = 29;
            offSet = 29;
            break;
        }
        case 6: {
            ratio = 2.5;
            defaultSize = 27;
            offSet = 27;
            break;
        }
        case 7: {
            ratio = 1.8;
            defaultSize = 20;
            offSet = 20;
            break;
        }
        case 8: {
            ratio = 1.7;
            defaultSize = 20;
            offSet = 20;
            break;
        }
        case 9: {
            ratio = 1.9;
            defaultSize = 24;
            offSet = 24;
            break;
        }
        case 10: {
            ratio = 4.0;
            defaultSize = 25;
            offSet = 25;
            break;
        }
        default: {
            ratio = 1.9;
            defaultSize = 22;
            offSet = 22;
            break;
        }
    }

    let fontSize = Math.floor(
        (selectedSize.width * selectedSize.height) / (name.length * ratio),
    );

    return fontSize > offSet ? defaultSize : fontSize;
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
